const Error = ({ error }) => {

    return (
        <span className="pension-wizard-block__error">{error}</span>
               
     )
}

export default Error;


